import { useContext } from "react";
import React from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import Card from "/src/components/Search/Card";
import Pager from "./Pager";

import { AppContext } from "/src/components/context/App";

function Results({ results, page, onPage, showPager }) {

  const context = useContext(AppContext);

  const data = results?.data || [];
  const totalPages = results?.totalPages || 0;

  const renderCard = (item) => {

    const colProps = context?.GET_SEARCH_RESULT_COL_PROPS?.({ data: item });
    const cardProps = context?.GET_SEARCH_RESULT_CARD_PROPS?.({ data: item });

    const searchResultCard = context?.GET_SEARCH_RESULT_CARD?.({ search_type: context.search_type, data: item });

    if (searchResultCard) {
      return (
        <Col key={item.id} {...colProps} onClick={cardProps?.onClick} dangerouslySetInnerHTML={{ __html: searchResultCard }} >
        </Col>
      );
    }
    return (
      <Col key={item.id} {...colProps}>
        <Card data={item} {...cardProps} />
      </Col>
    );

  }

  return (
    <Container fluid className="search-results d-flex flex-column gap-3">
      <Row className="gy-3 gx-3">
        {data.map(renderCard)}
      </Row>
      {showPager &&
      <Row className="gy-3 gx-3">
        <Pager page={page} totalPages={totalPages} onPage={onPage} />
      </Row>
      }
    </Container>
  );

}

export default Results;
